// ❗本文件关联入口文件，导包路径不能用"@"或"~"
// ❗此处的type必须在外部引入否则会报错，原因是该库用了更严格的import protection（impound 插件）。
import type { LocaleObject } from '@nuxtjs/i18n'
import { en, ms, th, vi, zh_cn, zh_tw } from '@nuxt/ui/locale'
import type { AppComponentItem } from '../types/common/item'
import { configIcon } from '../config/icon'

/** 受支持的语言代码，主要用于nuxt.config.ts自动生成路径 */
export const languageCodes = ['en', 'lo', 'ms', 'th', 'vi', 'zh-hans', 'zh-hant'] as const
/** 受支持的语言代码类型 */
export type LanguageCode = (typeof languageCodes)[number]

/** 语言标签配置 */
export const i18nLableConfig: Record<LanguageCode, AppComponentItem> = {
  en: {
    label: 'English',
    icon: configIcon.usa,
  },
  lo: {
    label: 'ພາສາລາວ',
    icon: configIcon.laos,
  },
  ms: {
    label: 'Malay',
    icon: configIcon.malaysia,
  },
  th: {
    label: 'ภาษาไทย',
    icon: configIcon.thailand,
  },
  vi: {
    label: 'Tiếng Việt',
    icon: configIcon.vietnam,
  },
  'zh-hans': {
    label: '简体中文',
    icon: configIcon.china,
  },
  'zh-hant': {
    label: '繁體中文',
    icon: configIcon.china_hk,
  },
}

/**
 * 当前i18n信息
 */
export function useI18nInfo() {
  const { locale, locales } = useI18n()

  /**
   * 获取当前语言位于nuxt.config.ts中的基础信息
   */
  const curLocaleInfo = computed<LocaleObject | undefined>(() => {
    return locales.value.find(i => i.code === locale.value)
  })

  /**
   * 根据nuxt-i18n当前语言，返回用于nuxt-ui组件库的i18n数据
   */
  const nuxtUiI18nMsg = computed(() => {
    switch (locale.value) {
      case 'en':
        return en
      case 'ms':
        return ms
      case 'th':
        return th
      case 'vi':
        return vi
      case 'zh-hans':
        return zh_cn
      case 'zh-hant':
        return zh_tw
      // 未匹配到
      default:
        return en
    }
  })

  return {
    curLocaleInfo,
    nuxtUiI18nMsg,
  }
}
